import { REGEXP_ONLY_DIGITS } from 'input-otp'
import type { Ref } from 'react'
import { InputOTP, InputOTPGroup, InputOTPSlot } from './ui/input-otp'

export interface OtpFieldProps {
	value: string
	onChange: (value: string) => void
	length: number
	invalid: boolean
	disabled?: boolean
	ref?: Ref<HTMLInputElement>
	onBlur?: () => void
}

/** An emailed sign-in code, one slot per digit. */
export function OtpField({ value, onChange, length, invalid, disabled, ref, onBlur }: OtpFieldProps) {
	return (
		<InputOTP
			ref={ref}
			id="code"
			name="code"
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			maxLength={length}
			pattern={REGEXP_ONLY_DIGITS}
			inputMode="numeric"
			autoComplete="one-time-code"
			required
			disabled={disabled}
			aria-invalid={invalid || undefined}
		>
			<InputOTPGroup>
				{Array.from({ length }, (_, index) => index + 1).map((slotNumber) => (
					<InputOTPSlot key={`otp-slot-${slotNumber}`} index={slotNumber - 1} />
				))}
			</InputOTPGroup>
		</InputOTP>
	)
}
